class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.mv_30_products = [
      '46834467766517',
      '46834467799285',
      '46834482610421',
      '46834395709685',
      '46487078240501',
      '46487081451765',
      '46834482643189',
      '46990128316661',
      '46990128349429',
    ];
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    // this.cartNotification = document.querySelector('cart-notification');

    // check if the current path has query param 'status=patients'
    this.isPatients = window.location.search.includes('status=patients');
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    // this.cartNotification.setActiveElement(document.activeElement);

    const res = await fetch('/cart.js');
    const data = await res.json();

    if (this.querySelector('form').dataset.productid === '7925066105077') {
      for (let i = 0; i < data.items.length; i++) {
        if (data.items[i].id === 43429472796917) {
          alert('You can only have one free baby shampoo in cart');
          return;
        }
      }
    }

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const payload = JSON.parse(serializeForm(this.form));

    if (payload['product-id'] == '8774962086133') {
      payload['selling_plan'] = 4150067445;
      payload['selling_plan_4150067445'] = 'subsave';
    }

    if (payload['product-id'] == '8774755549429') {
      payload['selling_plan'] = 4150034677;
      payload['selling_plan_4150034677'] = 'subsave';
    }

    if (payload['property']) {
      payload['properties'] = { [payload['property']]: true };
    }

    if (
      this.mv_30_products.includes(payload['id']) &&
      !window.location.search.includes('_mv_lp_25')
    ) {
      payload['properties'] = {
        ...payload['properties'],
        _mv_lp_30: 'true',
      };
    }

    if (this.isPatients) {
      payload['properties'] = {
        ...payload['properties'],
        _mv_lp_patients: 'true',
      };
    }

    if (window.location.search.includes('_mv_lp_33')) {
      payload['properties'] = {
        ...payload['properties'],
        _mv_lp_33: 'true',
      };
    }

    if (window.location.search.includes('_mv_lp_25')) {
      payload['properties'] = {
        ...payload['properties'],
        _mv_lp_25: 'true',
      };
    }

    //if 4weekPlanId is set, set the selling plan to the 4weekPlanId
    if (
      this.dataset['4weekPlanId'] !== undefined &&
      this.dataset['4weekPlanId'] !== ''
    ) {
      payload['selling_plan'] = this.dataset['4weekPlanId'];
    }

    const body = JSON.stringify({
      ...payload,
      // sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        Shopify.openCartDrawer();
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
